import React from 'react';
import { withContent } from '../../hoc/withContext';
import {
    PriceBannerBlockContainer,
    PriceBannerDescription,
    PriceBannerImageContainer,
    PriceBannerInformationContainer,
    PriceBannerPriceContainer,
    PriceBannerSubscriptionButton,
    UbisoftPlusLogoContainer
} from './PriceBannerBlockStyle';
import { IContent } from '../../types';
import PictureImage from '../utils/Picture';
import { getSvgComponent } from '../utils/svg';
import CONFIG from '../../config';
import { MULTI_ACCESS_KEY } from '../../constants';
import SubscriptionButton from '../utils/SubscriptionButton';

const IMAGE_NAME = 'trials_watch_dogs_background';

interface IPriceBannerProps {
    context?: IContent;
}

const PriceBannerBlock = ({ context }: IPriceBannerProps) => {
    return (
        <PriceBannerBlockContainer>
            <PriceBannerImageContainer>
                <PictureImage
                    images={[
                        {
                            imageName: IMAGE_NAME + '_desktop',
                            minWidth: 850
                        },
                        {
                            imageName: IMAGE_NAME + '_tablet',
                            minWidth: 461
                        },
                        {
                            imageName: IMAGE_NAME + '_mobile',
                            minWidth: 0
                        }
                    ]}
                    extension="png"
                    containsWebp={false}
                    altText={context.priceBanner.imgAlt}
                    className={['']}
                />
            </PriceBannerImageContainer>
            <PriceBannerInformationContainer>
                <UbisoftPlusLogoContainer>
                    {getSvgComponent('ubisoft')}
                </UbisoftPlusLogoContainer>
                <PriceBannerDescription
                    dangerouslySetInnerHTML={{
                        __html: context.priceBanner.description
                    }}
                />
                <PriceBannerPriceContainer>
                    <discover-components-subscription-price
                        locale={context.lang.split('_')[0]}
                        theme={CONFIG.isUPC ? 'uplay' : 'store'}
                        customTheme={CONFIG.isUPC ? 'uplay' : 'store'}
                        size="defaultSizes"
                        textColor={'white'}
                        ubisoftPlusAccountType={MULTI_ACCESS_KEY}
                    ></discover-components-subscription-price>
                </PriceBannerPriceContainer>
                <PriceBannerSubscriptionButton>
                    <SubscriptionButton
                        idToAttach={'priceBannerSubscriptionButton'}
                    />
                </PriceBannerSubscriptionButton>
            </PriceBannerInformationContainer>
        </PriceBannerBlockContainer>
    );
};

export default withContent(PriceBannerBlock);
